import React from 'react';
import classNames from 'classnames';
import { Input as AntdInput } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { InputProps as AntdInputProps } from 'antd/lib/input';

import cn from './styles.module.scss';

export interface PasswordInputProps extends AntdInputProps {
  label?: string,
  error?: string,
}

const AntdPasswordInput = AntdInput.Password;

export const PasswordInput = React.forwardRef(({
  className,
  size = 'large',
  error,
  label,
  name,
  ...props
}: PasswordInputProps, ref) => (
  <div className={classNames(cn.inputContainer, className)}>
    {label && (
      <label htmlFor={name} className={cn.label}>{label}</label>
    )}
    <AntdPasswordInput
      className={classNames(
        cn.input,
        {
          [cn.error]: Boolean(error),
        }
      )}
      name={name}
      size={size}
      ref={ref as any}
      {...props}
    />
    {!!error && (
      <div className={cn.errorContainer}>
        <ExclamationCircleFilled className={cn.icon} />
        {error}
      </div>
    )}
  </div>
));

PasswordInput.displayName = 'PasswordInput';
